import { AppState } from './../../../../App.state';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { HistoricoCreditosResponse } from 'src/app/base/domain/dto/historico-creditos.dto';
import { NovoDashboardService } from 'src/app/base/services/novo-dashboard.service';
import { DialogService } from 'src/app/global/services/dialog.service';
import { QueryOptions } from 'src/app/global/domain/query.options';

Chart.register(...registerables);

@Component({
  selector: 'app-dashboard-historico-creditos',
  templateUrl: './dashboard-historico-creditos.component.html',
  styleUrls: ['./dashboard-historico-creditos.component.css']
})
export class DashboardHistoricoCreditosComponent implements OnInit {

  @ViewChild('graficoHistoricoCreditos', { static: true })
  canvas!: ElementRef<HTMLCanvasElement>;

  documento: string = '';

  queryOptions = new QueryOptions({ pageSize: 100 });
  data: HistoricoCreditosResponse | null = null;
  chart?: Chart;
  searched: boolean = false;

  private itemVisibility: boolean[] = [];

  constructor(
    private service: NovoDashboardService,
    private appState: AppState,
    public dialogService: DialogService
  ) { }

  ngOnInit(): void { }

  public buscar(): void {
    if (!this.documento) {
      this.dialogService.feedbackError('Informe o CPF/CNPJ para consultar.');
      return;
    }
    this.loadDashboard();
  }

  private loadDashboard(): void {
    this.appState.isLoading = true;
    this.searched = true;
    this.queryOptions.params = { documento: this.documento };

    this.service.findAllHistoricoCreditos(this.queryOptions).subscribe({
      next: (response: HistoricoCreditosResponse) => {
        this.data = response;
        this.appState.isLoading = false;
      },
      error: () => {
        this.dialogService.feedbackError("Erro ao carregar o dashboard de histórico de créditos.");
        this.appState.isLoading = false;
      }
    });

  }
  public getDate(dateArray: any): Date | null {
    if (!dateArray || !Array.isArray(dateArray) || dateArray.length < 3) return null;
    return new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
  }
}
